export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_07_XESeries_end.8f5c352a.jpg";